export default __webpack_public_path__ + "static/media/roadMap-left-monkey.d7cbfc4b.svg";